"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPLoggerEventType = void 0;
var BPLoggerEventType;
(function (BPLoggerEventType) {
    BPLoggerEventType["PageView"] = "page_view";
    BPLoggerEventType["Login"] = "login";
    BPLoggerEventType["Logout"] = "logout";
    BPLoggerEventType["CreateUser"] = "create_user";
    BPLoggerEventType["UpdateUser"] = "update_user";
    BPLoggerEventType["StockSync"] = "stock_sync";
    BPLoggerEventType["AddToCart"] = "add_to_cart";
    BPLoggerEventType["SubmitShippingAddress"] = "submit_shipping_address";
    BPLoggerEventType["SubmitShippingMethod"] = "submit_shipping_method";
    BPLoggerEventType["AddPromoCode"] = "add_promo_code";
    BPLoggerEventType["RemovePromoCode"] = "remove_promo_code";
    BPLoggerEventType["SubmitPayment"] = "submit_payment";
    BPLoggerEventType["CompletePayment"] = "complete_payment";
    BPLoggerEventType["SubmitOrder"] = "submit_order";
    BPLoggerEventType["SyncOrderWithOrderHub"] = "sync_order_with_order_hub";
    BPLoggerEventType["SyncOrderWithD365"] = "sync_order_with_d365";
    BPLoggerEventType["BlockOrder"] = "block_order";
    BPLoggerEventType["GenerateCommercialInvoice"] = "generate_commercial_invoice";
    BPLoggerEventType["ReleaseOrder"] = "release_order";
    BPLoggerEventType["FulFillOrder"] = "fulfill_order";
    BPLoggerEventType["HandleShortage"] = "handle_shortage";
    BPLoggerEventType["CreateOrderInvoice"] = "create_order_invoice";
    BPLoggerEventType["CollectOrderPayment"] = "collect_order_payment";
    BPLoggerEventType["CloseOrder"] = "close_order";
})(BPLoggerEventType = exports.BPLoggerEventType || (exports.BPLoggerEventType = {}));
//# sourceMappingURL=bp-logger-event-type.js.map